/*
 * Pro 2.0 "8 Reasons" landing page interactions.
 * Delegated at document level (each section emits its own `.pro2-lp`
 * wrapper, so there can be several roots) and guarded against double-init
 * (the asset tag may appear once per section). Uses data-attributes only —
 * no global functions, no inline onclick — so nothing collides with the theme.
 */
(function () {
  'use strict';
  if (window.__pro2LPInit) return;
  window.__pro2LPInit = true;

  function init() {
    /* ---- Gallery thumbnails / colour swatches / expert flip (document-delegated) ---- */
    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-pro2-thumb]');
      if (thumb) {
        var scope = thumb.closest('.pro2-lp') || document;
        var img = scope.querySelector('[data-pro2-gallery-img]');
        if (img) img.src = thumb.getAttribute('data-pro2-thumb');
        scope.querySelectorAll('[data-pro2-thumb]').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        return;
      }

      var swatch = e.target.closest('[data-pro2-swatch]');
      if (swatch) {
        var sscope = swatch.closest('.pro2-lp') || document;
        var nameEl = sscope.querySelector('[data-pro2-color-name]');
        if (nameEl) nameEl.textContent = swatch.getAttribute('data-pro2-color') || '';
        sscope.querySelectorAll('[data-pro2-swatch]').forEach(function (s) { s.classList.remove('active'); });
        swatch.classList.add('active');
        // Drive the real cart: point the variant input at the matched variant id.
        var variantId = swatch.getAttribute('data-pro2-variant-id');
        if (variantId) {
          var variantInput = document.querySelector('#pro2-offer input[name="items[0][id]"]');
          if (variantInput) {
            variantInput.value = variantId;
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          buildGalleryForVariantId(variantId); // rebuild the per-variant slider
        } else {
          var fallbackSrc = swatch.getAttribute('data-pro2-swatch');
          var gimg = sscope.querySelector('[data-pro2-gallery-img]');
          if (gimg && fallbackSrc) gimg.src = fallbackSrc;
        }
        return;
      }

      var card = e.target.closest('[data-pro2-flip]');
      if (card) { card.classList.toggle('flipped'); return; }

      // Sticky "Protect my gums" → trigger the offer form's real add-to-cart button
      var sticky = e.target.closest('[data-pro2-sticky-atc]');
      if (sticky) {
        e.preventDefault();
        var addBtn = document.querySelector('#pro2-offer .btn.add');
        if (addBtn) addBtn.click();
      }
    });

    /* ---- Per-variant image slider (mirrors the PDP's alt-text media filtering) ---- */
    var offerImg = document.querySelector('#pro2-offer [data-pro2-gallery-img]');
    var thumbsEl = document.querySelector('#pro2-offer [data-pro2-auto-thumbs]');
    var pjEl = document.querySelector('product-main [data-product-json]') || document.querySelector('[data-product-json]');
    var pdata = null;
    if (pjEl) { try { pdata = JSON.parse(pjEl.textContent); } catch (err) { pdata = null; } }

    function pro2Sized(url, w) {
      if (!url) return url;
      if (url.indexOf('width=') > -1) return url;
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
    function pro2MediaSrc(m) {
      return (m && m.preview_image && m.preview_image.src) || (m && m.src) || '';
    }
    // Same rule as product_main.js filterMedia: alt "OptionName:val1,val2" gates by variant option;
    // untagged media shows for all. Subscription-only page → hide one-time-only hero slides.
    function pro2MediaMatches(media, variant) {
      if (!media.alt) return true;
      var parts = media.alt.split(';');
      for (var i = 0; i < parts.length; i++) {
        var seg = parts[i].trim();
        var ci = seg.indexOf(':');
        if (ci < 0) continue;
        var key = seg.slice(0, ci).trim();
        var vals = seg.slice(ci + 1).trim();
        var optIdx = pdata.options.indexOf(key);
        if (optIdx >= 0) {
          var allowed = vals.split(',').map(function (v) { return v.trim(); });
          if (allowed.indexOf(variant.options[optIdx]) === -1) return false;
        }
      }
      var lower = media.alt.toLowerCase().split(';').map(function (s) { return s.trim(); });
      var hasSub = lower.indexOf('hero:sub') > -1;
      var hasOne = lower.indexOf('hero:onetime') > -1;
      if ((hasSub || hasOne) && !hasSub) return false;
      return true;
    }
    function pro2VariantById(id) {
      if (!pdata) return null;
      id = String(id);
      for (var i = 0; i < pdata.variants.length; i++) {
        if (String(pdata.variants[i].id) === id) return pdata.variants[i];
      }
      return null;
    }
    function buildGalleryForVariantId(id) {
      if (!pdata || !offerImg) return;
      var variant = pro2VariantById(id);
      if (!variant) return;
      var list = pdata.media
        .filter(function (m) { return m.media_type ? m.media_type === 'image' : true; })
        .filter(function (m) { return pro2MediaMatches(m, variant); });
      if (!list.length && variant.featured_image) {
        list = [{ id: variant.featured_image.id, src: variant.featured_image.src }];
      }
      if (!list.length) return;
      offerImg.src = pro2Sized(pro2MediaSrc(list[0]), 800);
      if (thumbsEl) {
        thumbsEl.innerHTML = '';
        if (list.length > 1) {
          list.forEach(function (m, idx) {
            var div = document.createElement('div');
            div.className = 'offer-gallery-thumb' + (idx === 0 ? ' active' : '');
            div.setAttribute('data-pro2-thumb', pro2Sized(pro2MediaSrc(m), 800));
            var im = document.createElement('img');
            im.src = pro2Sized(pro2MediaSrc(m), 200);
            im.loading = 'lazy';
            im.alt = '';
            div.appendChild(im);
            thumbsEl.appendChild(div);
          });
        }
      }
    }

    // Rebuild on variantChange (dispatched on product-main, doesn't bubble) and on initial load.
    var productMain = document.querySelector('product-main');
    if (productMain) {
      productMain.addEventListener('variantChange', function (e) {
        var v = e.detail && e.detail.variant;
        if (v) buildGalleryForVariantId(v.id);
      });
    }
    if (pdata && offerImg) {
      var initInput = document.querySelector('#pro2-offer input[name="items[0][id]"]');
      if (initInput && initInput.value) buildGalleryForVariantId(initInput.value);
    }

    /* ---- "Ships today" countdown to end of day ---- */
    var countdown = document.querySelector('[data-pro2-countdown]');
    if (countdown) {
      var tick = function () {
        var now = new Date();
        var end = new Date();
        end.setHours(23, 59, 59, 0);
        var diff = end - now;
        if (diff <= 0) { countdown.textContent = '0hr 0min'; return; }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        countdown.textContent = h + 'hr ' + m + 'min ' + s + 'sec';
      };
      tick();
      setInterval(tick, 1000);
    }

    /* ---- Sticky CTA bar (hidden while the offer section is in view) ---- */
    var bar = document.querySelector('.pro2-lp-sticky-cta');
    var offer = document.getElementById('pro2-offer');
    if (bar) {
      var onScroll = function () {
        var show = window.scrollY > 700;
        if (offer) {
          var r = offer.getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) show = false;
        }
        bar.classList.toggle('visible', show);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
